var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.$t('HardwareSelector.label'),"items":_vm.hardwares,"item-text":"label","item-value":"value","filled":"","hide-details":"auto","clearable":"","append-icon":"mdi-chevron-down"},model:{value:(_vm.hardware),callback:function ($$v) {_vm.hardware=$$v},expression:"hardware"}})
}
var staticRenderFns = []

export { render, staticRenderFns }